import { ImagesRoute } from "@/modules/images/routes/images.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/images/")({
	component: ImagesRoute,
});
